// JS
import '../../custom/js/index';

// Base SCSS
import '../../custom/scss/base.scss';
import '../../custom/scss/layout.scss';

// Components SCSS
import '~/src/custom/scss/components/breadcrumb/breadcrumb.scss';
import '~/src/custom/scss/components/hero/hero.scss';
import '~/src/custom/scss/components/category-overview/category-overview.scss';
import '~/src/custom/scss/pagebuilder.scss';
import '~/src/common/scss/components/pagination/pagination.scss';
import '~/src/common/scss/components/content-listing/content-listing.scss';
import '~/src/custom/scss/components/blog/blog.scss';

// import Vue App
import Vue from 'vue';
import VueApp from '~/src/common/vue/apps/list-filter.js';
import App from '~/src/common/vue/apps/containers/content-list-filter-app.vue';

// connect vue component and init app
Vue.component('app', App);
VueApp.$mount('#filter-app');